let instances = [];

class CarFilters {
    /**
     * Binding our event listener to the checkbox.
     *
     * @param {HTMLElement} element
     */
    constructor(element) {
        this.element = element;

        this.selectedFilters = {
            type: [],
            brand: [],
            range: "",
        };

        this.bindEvents();
    }

    /**
     * Adds on change/click event listeners.
     *
     * @return {void}
     */
    bindEvents() {
        const listener = () => {
            this.applyFiltersToFilterComponent();
        };

        const applyBrands = document.querySelector("#apply");
        const types = document.querySelectorAll("input[name*=type]");
        const ranges = document.querySelectorAll("input[name*=range]");

        applyBrands.addEventListener("click", listener);

        types.forEach((element) => {
            element.addEventListener("change", listener);
        });

        ranges.forEach((element) => {
            element.addEventListener("change", listener);
        });

        window.addEventListener("load", listener);
    }

    /**
     * Iterates over the different filters in order to save the selection into the component state and append
     * the selection to the URL.
     *
     * @return {void}
     */
    applyFiltersToFilterComponent() {
        Object.keys(this.selectedFilters).forEach((filterType) => {
            this.getFilters(filterType);
        });

        this.appendFiltersToUrl();
    }

    /**
     * Saves into the component state any values selected for a particular filter defined by the `type` parameter.
     *
     * @param {String} type
     * @return {void}
     */
    getFilters(type) {
        if (type === "range") {
            this.selectedFilters[type] = "";
        }

        document.querySelectorAll(`input[name*=${type}]`).forEach((filter) => {
            const checked = filter.checked;

            if (type === "range" && checked) {
                if (filter.value === "rangeAll") {
                    this.selectedFilters[type] = "";
                } else {
                    this.selectedFilters[type] = filter.value;
                }
            } else {
                const selected = this.selectedFilters[type].includes(filter.value);

                if (checked && !selected) {
                    this.selectedFilters[type].push(filter.value);
                } else if (!checked && selected) {
                    this.selectedFilters[type] = this.selectedFilters[type].filter((value) => value !== filter.value);
                }
            }
        });
    }

    /**
     * Iterating through our selectedFilters and append the selected values into the query string of the URL.
     *
     * @return {void}
     */
    appendFiltersToUrl() {
        const url = new URL(`${window.location.protocol}//${window.location.hostname}${window.location.pathname}`);
        const params = new URLSearchParams();

        Object.keys(this.selectedFilters).forEach((filterType) => {
            if (this.selectedFilters[filterType].length > 0) {
                params.append(filterType, this.selectedFilters[filterType].toString());
            }
        });

        const newUrl = `${url.toString()}?${decodeURIComponent(params.toString())}`;

        window.history.pushState({}, document.title, newUrl);

        this.applyFiltersToCards();
    }

    /**
     * Checks if there is no filters selected.
     *
     * @return {Boolean}
     */
    areFiltersEmpty() {
        return (
            this.selectedFilters.type.length === 0 &&
            this.selectedFilters.brand.length === 0 &&
            this.selectedFilters.range.length === 0
        );
    }

    /**
     * If filters are empty display all the vehicle cards, if not,
     * hide all cards and iterate over them to display the ones that match the filters selected by the user.
     *
     * @return {void}
     */
    applyFiltersToCards() {
        const vehicleCards = document.querySelectorAll(".selectable-vehicle-card");

        if (this.areFiltersEmpty()) {
            Object.values(vehicleCards).forEach((vehicleCard) => {
                CarFilters.displayCard(vehicleCard);
            });

            return;
        }

        let noResults = true;

        Object.values(vehicleCards).forEach((vehicleCard) => {
            CarFilters.hideCard(vehicleCard);
        });

        Object.values(vehicleCards).forEach((vehicleCard) => {
            const brand = vehicleCard.attributes["data-model-brand"].value;
            const type = vehicleCard.attributes["data-model-type"].value;
            const range = vehicleCard.attributes["data-model-range"].value;

            if (this.shouldCardBeDisplayed(brand, type, range)) {
                CarFilters.displayCard(vehicleCard);

                noResults = false;
            }
        });

        const noResultsCopy = document.querySelector("#no-results");
        const isHidden = noResultsCopy.classList.contains("hidden");

        if (noResults && isHidden) {
            noResultsCopy.classList.remove("hidden");
        } else if (!noResults && !isHidden) {
            noResultsCopy.classList.add("hidden");
        }
    }

    /**
     * Checks if the current card should be displayed or not depending on if the brand, type and range on the vehicle match the selected filters.
     *
     * @param {String} brand
     * @param {String} type
     * @param {String} range
     * @return {Boolean}
     */
    shouldCardBeDisplayed(brand, type, range) {
        let display = true;

        Object.keys(this.selectedFilters).forEach((filterKey) => {
            if (this.selectedFilters[filterKey] === "" || this.selectedFilters[filterKey].length === 0) {
                return;
            }

            switch (filterKey) {
                case "brand":
                    if (!this.selectedFilters.brand.includes(brand)) {
                        display = false;
                    }

                    break;
                case "type":
                    if (!this.selectedFilters.type.includes(type)) {
                        display = false;
                    }

                    break;
                case "range":
                    if (this.selectedFilters.range !== range) {
                        display = false;
                    }

                    break;
                default:
                    break;
            }
        });

        return display;
    }

    /**
     * Removes hidden class from HTML element.
     *
     * @param {Element} vehicleCard
     * @return {void}
     */
    static displayCard(vehicleCard) {
        vehicleCard.classList.remove("hidden");
    }

    /**
     * Adds hidden class on HTML element.
     *
     * @param {Element} vehicleCard
     * @return {void}
     */
    static hideCard(vehicleCard) {
        vehicleCard.classList.add("hidden");
    }
}

export default {
    init: (element) => {
        instances.push(new CarFilters(element));
    },

    destroy: () => {
        instances.forEach((instance) => instance.unbindEvents());
        instances = [];
    },
};
